import React, {FC, useState} from 'react';
import {useParams} from 'react-router-dom';

import NoMatch from '../../components/NoMatch';
import {runsTableRunFromQueryData} from '../../components/RunsTable';
import {InstrumentedLoader as Loader} from '../../components/utility/InstrumentedLoader';
import {UserAccountType, useUserRunsQuery} from '../../generated/graphql';
import {propagateErrorsContext} from '../../util/errors';
import {EntityOverviewPage} from '../Team/EntityOverviewPage';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {ProfilePageQueryData} from './ProfilePageNew';

type OverviewProps = {
  data: ProfilePageQueryData['user'];
  userHasPublicReports: boolean;
  customizeShowcasedReportsModalOpen: boolean;
  openCustomizeShowcasedReportsModal: () => void;
  closeCustomizeShowcasedReportsModal: () => void;
};

export const ProfileOverview: FC<OverviewProps> = ({data}) => {
  const {entityName} = useParams<{entityName: string}>();
  const [runNameSearchStr, setRunNameSearchStr] = useState<string>('');
  const {data: userRunsQuery, loading: isUserRunsLoading} = useUserRunsQuery({
    variables: {
      username: entityName,
      pattern: runNameSearchStr,
      first: 100,
    },
    context: propagateErrorsContext(),
  });
  const userRuns = runsTableRunFromQueryData(userRunsQuery?.user?.runs);

  if (data == null) {
    return <Loader name="null-data-loader" />;
  }

  if (data.accountType === UserAccountType.Anonymous) {
    return <NoMatch />;
  }

  return (
    <EntityOverviewPage
      setRunNameSearchStr={setRunNameSearchStr}
      entityName={entityName}
      runs={userRuns}
      runsIsLoading={isUserRunsLoading}
      analyticsLocation={'profile page overview'}
      isTeamPage={false}
    />
  );
};
